module.exports = __webpack_public_path__ + "img/929.d8a393a1.png";